__webpack_require__.p = "https://qa-bigfoot.gupshup.io/ingress/";